import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "../../../../components/index";
import { SuittService } from "../../../../services";
import { Box, Button, CircularProgress, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { snackActions } from "../../../../utils/SnackBarUtils";
import { Alert } from "@mui/lab";

function UserSettings({ user = {} }) {
  const suittService = new SuittService();
  const navigate = useNavigate();

  const [passwordForm, setPasswordForm] = useState({
    password: "",
    passwordConfirm: "",
    loading: false,
    passwordError: false,
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const splittedName = name.split(".");
    if (splittedName.length > 1) {
      setPasswordForm({
        ...passwordForm,
        [splittedName[0]]: {
          ...passwordForm[splittedName[0]],
          [splittedName[1]]: value,
        },
      });
    } else {
      setPasswordForm({ ...passwordForm, [name]: value });
    }
  };

  const resetPassword = async () => {
    setPasswordForm({ ...passwordForm, loading: true, passwordError: false });
    if (
      !passwordForm.password ||
      !passwordForm.passwordConfirm ||
      passwordForm.password !== passwordForm.passwordConfirm
    ) {
      return setPasswordForm({
        ...passwordForm,
        loading: false,
        passwordError: true,
      });
    }

    setTimeout(async () => {
      const result = await suittService.resetUserPassword(
        user._id,
        passwordForm.password
      );
      if (result.status) {
        setPasswordForm({
          ...passwordForm,
          loading: false,
          passwordError: false,
        });
        snackActions.success("Пароль успішно змінено");
        navigate(`/cabinet/users/${user._id}`);
      }

      setPasswordForm({ ...passwordForm, loading: false });
    }, 500);
  };

  if (passwordForm.loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <CircularProgress color={"secondary"} />
      </Box>
    );
  }

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Grid container sx={{ padding: "10px 0" }} spacing={1}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Alert severity={"info"}>Пароль має бути не менше 8 символів!</Alert>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <TextField
            placeholder={"Новий пароль"}
            label={"Новий пароль"}
            variant="outlined"
            fullWidth
            value={passwordForm.password}
            type={"password"}
            name={"password"}
            onChange={handleInputChange}
            helperText={"Вкажіть новий пароль"}
            error={passwordForm.passwordError}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <TextField
            placeholder={"Повторіть новий пароль"}
            label={"Повторіть новий пароль"}
            variant="outlined"
            fullWidth
            value={passwordForm.passwordConfirm}
            type={"password"}
            name={"passwordConfirm"}
            onChange={handleInputChange}
            helperText={"Повторно вкажіть новий пароль"}
            error={passwordForm.passwordError}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <Button
            onClick={resetPassword}
            variant={"contained"}
            fullWidth
            size={"large"}
          >
            Оновити
          </Button>
        </Grid>
      </Grid>
    </ErrorBoundary>
  );
}

export default UserSettings;
